import { EmailRecord } from 'types';

export const getHourOptions = () => {
  const hours = [];
  for (let i = 1; i <= 12; i += 1) {
    hours.push({ value: i.toString(), label: i.toString() });
  }
  return hours;
};

export const getMinuteOptions = () => {
  const minutes = [];
  for (let i = 0; i < 60; i += 5) {
    const paddedMinute = i < 10 ? `0${i}` : i.toString();
    minutes.push({ value: paddedMinute, label: paddedMinute });
  }
  return minutes;
};

export const getEmailOptions = (emailRecords: EmailRecord[]) =>
  emailRecords.map((record) => ({
    value: record.email,
    label: record.email
  }));
